//TODO: DisplayContent for NextDrawings
//TODO: DisplayContent for RecentDrawings

import React from 'react';
import { connect } from 'react-redux';
import { getCMSObject, NextDrawings, formatDateTBD, RecentDrawings, ErrorBoundary, TeleScript, DisplayContent } from 'sg-ui-components';
import { mapStateToProps, mapDispatchToProps } from '../Store';
import Layout from '../Components/Layout';
import WinnerLinkWrapper from '../Components/WinnerLinkWrapper';

const WinnersPage = ({ user, config, winner, cmsSourceFirebase, actions, match }) => {
    const path = match.path;

    const telescriptNextDrawings = getCMSObject('data.components.teleScripts.nextDrawings.jsonBlock');
    const telescriptRecentSecondChanceDrawings = getCMSObject('data.components.teleScripts.recentSecondChanceDrawings.jsonBlock');
    const telescriptRecentPFDDrawings = getCMSObject('data.components.teleScripts.recentPFDDrawings.jsonBlock');

    return (
        <Layout {...{ user, config, cmsSourceFirebase, actions, path, match }}>
            <DisplayContent note='Show Winners Next Drawing section' isVisible={config?.web?.features?.winnersNextDrawing}>
                <ErrorBoundary fallback={<TeleScript line={telescriptNextDrawings?.fallback} />} details={{ user, config }}>
                    <NextDrawings
                        {...{ user, winner, cmsSourceFirebase, actions }}
                        formatDate={formatDateTBD?.dateWithDayOfTheWeek}
                        telescript={telescriptNextDrawings ?? ''}
                        options={
                            config?.site?.components?.winnersNextDrawing ?? {
                                variant: 'theme-primary',
                                limitOnePerSweepstake: true,
                                maxElement: 5,
                            }
                        }
                    />
                </ErrorBoundary>
            </DisplayContent>

            <ErrorBoundary fallback={<TeleScript line={telescriptRecentSecondChanceDrawings?.fallback} />} details={{ user, config }}>
                <RecentDrawings
                    winner={winner}
                    actions={actions}
                    entryType={config?.web?.features?.pointsForDrawings ? 'promotion' : undefined}
                    telescript={telescriptRecentSecondChanceDrawings}
                    WinnerLink={WinnerLinkWrapper}
                    options={
                        config?.site?.components?.recentDrawings ?? {
                            variant: 'theme-primary',
                            hasCollapser: true,
                            hash: 'recent-drawings',
                            pageSize: 10,
                        }
                    }
                />
            </ErrorBoundary>

            <DisplayContent note='Show Recent Drawings section for PFD' isVisible={config?.web?.features?.pointsForDrawings}>
                <ErrorBoundary fallback={<TeleScript line={telescriptRecentPFDDrawings?.fallback} />} details={{ user, config }}>
                    <RecentDrawings
                        winner={winner}
                        actions={actions}
                        entryType={'purchase'}
                        telescript={telescriptRecentPFDDrawings}
                        WinnerLink={WinnerLinkWrapper}
                        createDetailsLink={(sweepsId) => `/points-for-drawing-details/${sweepsId}`}
                        options={
                            config?.site?.components?.recentDrawingsPFD ?? {
                                isVisible: config?.site?.components?.recentDrawings?.isVisible ?? true,
                                variant: 'theme-primary',
                                hasCollapser: true,
                                hash: 'recent-drawings',
                                pageSize: config?.site?.components?.recentDrawings?.defaultPageSize ?? 10,
                                linkOlderDrawings: `${config.config.store_uri}/users/drawing_orders.php`,
                            }
                        }
                    />
                </ErrorBoundary>
            </DisplayContent>
        </Layout>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(WinnersPage);
